export default {
  durationData: {
    showDay: [1, 2, 3, 4, 5, 6, 7],
    showTime: [9, 13, 14, 18],
  },
  dateFormat: '%Y-%m-%d %H:%i:%s',
  touchEnable: false,
  stableGridWidth: false,
  roundDndDates: true,
  discolorationTasks: false,
  crossOutTasks: false,
};
